'use strict';

function isUndefined(o) {
  return o === undefined;
}

module.exports = isUndefined;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/isUndefined.js
// module id = 37
// module chunks = 1